import {noop} from "lodash";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import {
    Claim_Add,
    Claim_Detail,
    Claim_List,
    Create_Customer,
    Customer_Choice, Export_Inventory_Product,
    Owner_List,
    Ticket_Assignee_List, Ticket_Management_Export,
    Ticket_Management_List,
    Ticket_Save
} from "../../config";
import api from "../../api/api";
import {InboundsActionType} from "../inbounds/inboundsAction";
import {useState} from "react";
import moment from "moment/moment";


export const SET_TICKET_REFRESH = "SET_TICKET_REFRESH";

export const ticketManagementFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SupportTicketList)) return null;
        const url = `${Ticket_Management_List}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:SystemActionType.Storage_FeeAuthority_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const ticketDetail = (data, onSuccess = noop,onError = noop) => async dispatch => {
    if (!checkPermission(PERMISSION_DICT.SupportTicketDetail)) return null;
    const ticketId = data.ticketId
    const url = `/support/ticket/${ticketId}/detail`
    const response = await api.post(url,{ownerId:data?.ownerId})
    if(response?.status === 200 && response.data.code === 200){

        onSuccess(response.data?.data?.ticketDetailInfoResp)
    } else {

        onError(response.data.msg,response?.data.code)
    }
}


export const addTicket =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.SupportTicketCreate)) return null;
        const url = `${Ticket_Save}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess("TicketPage.Ticket created successfully")
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const addTicketComment =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        const ticketId = data.ticketId
        const url = `/support/ticket/${ticketId}/comment`

        if (!checkPermission(PERMISSION_DICT.SupportTicketComment)) return null;

        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess("TicketPage.Ticket Comment Added successfully")
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}


export const updateTicketComment =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        const ticketId = data.ticketId
        const commentId = data.commentId
        const url = `/support/ticket/${ticketId}/comment/${commentId}/edit`

        if (!checkPermission(PERMISSION_DICT.SupportTicketCommentEdit)) return null;

        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess("TicketPage.Ticket Comment Edited successfully")
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const deleteTicketComment = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        const { ticketId, commentIds } = data;

        if (!checkPermission(PERMISSION_DICT.SupportTicketCommentDelete)) return null;

        const url = `/support/ticket/${ticketId}/comments/delete`;

        const response = await api.post(url, {
            commentIds
        });

        if (response?.status === 200 && response.data.code === 200) {
            onSuccess("TicketPage.Ticket Comment Deleted successfully");
        } else {
            onError(response.data.msg);
        }

    } catch (e) {
        onError(e.message);
    }
};

export const getTicketAssignee = (onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.SupportTicketAssignee)) return null;
        const url = `${Ticket_Assignee_List}`
        const response = await api.get(url)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response.data?.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }
}


export const updateTicket =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {
        const ticketId = data.ticketId
        if (!checkPermission(PERMISSION_DICT.SupportTicketUpdate)) return null;
        const url = `/support/ticket/${ticketId}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess("TicketPage.Ticket Status Updated successfully")
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}


export const markCommentsAsRead = (data, onSuccess = noop, onError = noop) => async dispatch => {


    const url = `/support/ticket/comments/read`;
    if (!checkPermission(PERMISSION_DICT.SupportTicketCommentRead)) return null;
    try {
        const response = await api.post(url, data);


        if (response?.status === 200 && response.data.code === 200) {
            onSuccess(response.data?.data);
        } else {
            onError(response?.data?.msg, response?.data?.code);
        }
    } catch (err) {
        onError(err?.message);
    }
};


export const claimListFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        // if (!checkPermission(PERMISSION_DICT.SupportTicketList)) return null;
        const url = `${Claim_List}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:SystemActionType.Storage_FeeAuthority_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const addClaim = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        const response = await api.post(Claim_Add, data);
        if (response?.status === 200 && response.data.code === 200) {
            onSuccess(response.data);
        } else {
            onError(response.data.msg, response?.data.code);
        }
    } catch (e) {
        onError(e.message);
    }
};

export const claimDetail = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        const response = await api.post(Claim_Detail, null, {
            params: { claimId: data?.claimId },
        });
        if (response?.status === 200 && response.data.code === 200) {
            onSuccess(response.data);
        } else {
            onError(response.data.msg, response?.data.code);
        }
    } catch (e) {
        onError(e.message);
    }
};

export const addClaimComment = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        const claimId = data?.claimId;
        const url = `/support/claim/${claimId}/comment`;
        const response = await api.post(url, {
            attachmentUrlList: data?.attachmentUrlList || [],
            commentContent: data?.commentContent || "",
        });

        if (response?.status === 200 && response.data.code === 200) {
            onSuccess(response.data);
        } else {
            onError(response.data.msg, response?.data.code);
        }
    } catch (e) {
        onError(e.message);
    }
};

export const agentUpdateClaimStatus = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SupportClaimAgentUpdateStatus)) return null;

        const response = await api.post("/support/claim/agent/updateStatus", {
            claimId: data?.claimId,
            status: data?.status,
            ticketNumber: data?.ticketNumber || "",
            rejectedReason: data?.rejectedReason || "",
        });

        if (response?.status === 200 && response.data.code === 200) {
            onSuccess(response.data);
        } else {
            onError(response.data.msg, response?.data.code);
        }
    } catch (e) {
        onError(e.message);
    }
};

export const customerUpdateClaimStatus = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SupportClaimCustomerUpdateStatus)) return null;

        const response = await api.post("/support/claim/customer/updateStatus", {
            claimId: data?.claimId,
            status: data?.status,
        });

        if (response?.status === 200 && response.data.code === 200) {
            onSuccess(response.data);
        } else {
            onError(response.data.msg, response?.data.code);
        }
    } catch (e) {
        onError(e.message);
    }
};

export const accountingUpdateClaimStatus = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SupportClaimAccountingUpdateStatus)) return null;

        const response = await api.post("/support/claim/accounting/updateStatus", {
            chargeCurrency: data?.chargeCurrency || "",
            claimId: data?.claimId,
            creditApprovedValue: data?.creditApprovedValue,
            paymentMethod: data?.paymentMethod || "",
            receivedDate: data?.receivedDate || "",
        });

        if (response?.status === 200 && response.data.code === 200) {
            onSuccess(response.data);
        } else {
            onError(response.data.msg, response?.data.code);
        }
    } catch (e) {
        onError(e.message);
    }
};


export const ticketManagementFilterExport = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.SupportTicketExport)) return null;
        const xurl = `${Ticket_Management_Export}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });


        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Ticket_Management_List_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}